import EnduranceTrainingTypeManagement from '../../../components/enduranceTrainingType/EnduranceTrainingTypeManagement';
import { ReactElement } from 'react';

const AdminEnduranceTrainingTypes = (): ReactElement => {
  return (
    <EnduranceTrainingTypeManagement mode="admin" />
  )
}

export default AdminEnduranceTrainingTypes